<div class="spinner-container">
  <div class="spinner-value">
    <span>{{ remainingAnswers }}</span>
  </div>
  <mat-progress-spinner [value]="progressValue" aria-label="answers left"> </mat-progress-spinner>
</div>
